import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {TopAppBarSection as RmwcTopAppBarSection} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const StyledRmwcTopAppBarSection = styled(RmwcTopAppBarSection)``

const TopAppBarSection = ({children, ...otherProps}) => <StyledRmwcTopAppBarSection {...otherProps}>{children}</StyledRmwcTopAppBarSection>

TopAppBarSection.propTypes = {
  children: PropTypes.any
}

export {TopAppBarSection}
